import { withJsonFormsControlProps } from '@jsonforms/react';
import { Date } from './Date';

const DateControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <Date
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(DateControl);
